import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image";
import React from "react";
import { EmbeddedAsset } from "../../../graphql-types";

type Props = {
  asset: EmbeddedAsset;
  caption: string;
};

export default function ImageWithCaption({ asset, caption }: Props) {
  const image = getImage(
    asset.file.fileLocal as unknown as ImageDataLike
  ) as IGatsbyImageData;

  return (
    <figure className="rich-text__figure">
      <GatsbyImage alt={asset.description} image={image} />
      <figcaption>{caption}</figcaption>
    </figure>
  );
}
